import SelectorUbicacion from '../SelectorUbicacion';

export const empresaSchema = {
  fields: [
    {
      name: 'descripcio',
      type: 'text',
      label: 'Nombre de la Empresa',
      required: true,
      placeholder: 'ej: ENVASES DE LA TORRE',
      gridSpan: 'full',
      format: 'uppercase'
    },
    {
      name: 'nosucursal',
      type: 'number',
      label: 'Número de Sucursal',
      required: false,
      placeholder: 'ej: 6',
      gridSpan: 'auto'
    },
    {
      name: 'email',
      type: 'email',
      label: 'Email de Contacto',
      required: false,
      placeholder: 'ej: contacto@empresa.com',
      gridSpan: 'auto'
    },
    {
      name: 'ubicacion',
      type: 'custom',
      component: SelectorUbicacion,
      label: 'Ubicación Geográfica',
      required: true,
      gridSpan: 'full',
      validation: {
        custom: (value) => {
          if (!value.estado || !value.municipio) {
            return 'Debe seleccionar estado y municipio';
          }
          return true;
        }
      }
    },
    {
      name: 'activo',
      type: 'checkbox',
      label: 'Empresa activa',
      required: false,
      gridSpan: 'full'
    }
  ]
};